import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzButtonSize } from 'ng-zorro-antd/button';

@Component({
  selector: 'app-view-button',
  templateUrl: './view-button.component.html',
  styleUrl: './view-button.component.scss',
})
export class ViewButtonComponent {
  @Input() text: string = '';
  @Input() type: 'primary' | 'default' | 'dashed' | 'text' | 'link' = 'default';
  @Input() shape: 'circle' | 'round' | null = null;
  @Input() size: NzButtonSize = 'default';
  @Input() danger: boolean = false;
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() ghost: boolean = false;
  @Input() icon: string | null = null;
  @Input() block: boolean = false;
  @Input() href: string | null = null;

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (!this.disabled && !this.loading) {
      this.buttonClick.emit(event);
    }
  }
}

// todo : usage example

// <app-button
//   text="Primary Button"
//   type="primary"
//   [size]="'large'"
//   [icon]="'plus'"
//   [loading]="false"
//   [disabled]="false"
//   (buttonClick)="onButtonClick($event)"
// ></app-button>

// <app-button
//   text="Danger Button"
//   type="primary"
//   [danger]="true"
//   [icon]="'delete'"
//   (buttonClick)="onButtonClick($event)"
// ></app-button>
